export default {
  primary: {
    backgroundColor: 'primary',
    borderRadius: '1000px',
    fontFamily: 'heading',
    color: 'light',
    fontWeight: 'bold',
    backgroundSize: '204% 100%',
    backgroundColor: '#4584f5',
    backgroundImage: 'linear-gradient(to left,rgba(0,0,0,0) 50%,#203d78 50%)',
    padding: '1.5rem 3rem',
    fontSize: '1rem',
    textDecoration: 'none',
    textTransform: 'uppercase',
    transition: 'all ease-in-out 1s',
    opacity: '1',
    border: 'none',
    ':hover': {
      // backgroundColor: 'transparent',
      backgroundPosition: '-98% 0%',
      color: 'light'
    }
  },
  secondary: {
    backgroundColor: 'transparent',
    color: 'primary',
    border: 'solid 2px',
    borderColor: 'primary',
    ':hover': {
      backgroundColor: 'primary',
      color: 'white'
    }
  }
}
